import React, { useState } from "react";
import SheetOrDialog from "../ui/SheetOrDialog";

const PHRASE = "DELETE";

function Body({ onExport, onConfirm, onCancel }) {
  const [typed, setTyped] = useState("");
  const ready = typed === PHRASE;
  return (
    <div className="pf-delete">
      <h2 className="pf-delete-title">Delete your account?</h2>
      <p className="pf-delete-text">
        This permanently deletes your account, all your chats and your sign-in. It can't be undone. You can download your data first.
      </p>
      <button type="button" className="pf-btn" onClick={onExport}>
        Download my data first
      </button>
      <label className="pf-delete-label" htmlFor="pf-delete-input">
        Type {PHRASE} to confirm
      </label>
      <input
        id="pf-delete-input"
        className="pf-delete-input"
        type="text"
        value={typed}
        onChange={(e) => setTyped(e.target.value)}
        autoComplete="off"
        autoCapitalize="characters"
        spellCheck="false"
      />
      <button type="button" className="pf-btn pf-btn--danger-solid" disabled={!ready} onClick={onConfirm}>
        Delete my account
      </button>
      <button type="button" className="pf-btn" onClick={onCancel}>
        Cancel
      </button>
    </div>
  );
}

// Confirmation for deleting the account: a bottom sheet on phones, a centred dialog on wide screens.
// The red button stays off until the student types DELETE exactly.
export default function DeleteAccountSheet({ open, onClose, onExport, onConfirm }) {
  return (
    <SheetOrDialog open={open} onClose={onClose} label="Delete your account">
      <Body onExport={onExport} onConfirm={onConfirm} onCancel={onClose} />
    </SheetOrDialog>
  );
}
